<template>
<div class="center">
    <vs-dialog :id="idModal" overflow-hidden not-padding not-close prevent-close :width="modalWidth" not-center v-model="activeModal">
        <h6 class="border-bottom header-modal">{{ textHeader }}</h6>

       <div class="container pb-2">
            <div class="pt-3 px-2">
                <slot></slot>
            </div>
            
            <!-- <div v-if="!modalForm" class="pt-2 d-flex justify-content-end">
                <button @click="activeModal=false, eventoCerrar()"  class="btn btn-danger-o me-2 my-1 px-4">Cerrar</button>
                <vs-button @click="eventoConfirmar()" class="btn-success px-3">Aceptar</vs-button>
            </div> -->
       </div>
    </vs-dialog>
</div>
    
</template>

<script>
export default ({
    created(){
        window.scrollTo(0, 0);
    },
    name: 'componenteModal',
    data: function() {
        return{
            activeModal: true,
            confirmar: false,
        }
    },
    props:{
        idModal:{
            type: String,
            default: 'modal'
        },
        textHeader:{
            type: String,
            default: ''
        },
        modalWidth:{
            type: String,
            default: '500px'
        },
        // modalForm:{
        //     type: Boolean,
        //     default: false
        // }
    },
    methods:{
        eventoCerrar(){
            this.$emit('verModal', false)
            // lo dejo en true para q vuelva a entrar y sea visible
            this.activeModal = true; 
            this.confirmar = false;
        },
        eventoConfirmar(){
            this.confirmar = true;
            this.$emit('confirmar', this.confirmar);
            this.confirmar = false;

            this.$emit('verModal', false)
        }
    }
})
</script>
